import { jsx as a } from "react/jsx-runtime";
import { useState as l } from "react";
import { attributes as p } from "../utils/attributes.js";
import '../../assets/ButtonIcon.css';function A({
  Icon: s,
  onClick: t,
  onMouseEnter: i,
  onMouseLeave: e,
  className: m = "",
  animation: r,
  disabled: n = !1,
  variant: c = "big"
}) {
  const [u, o] = l(""), b = () => {
    o("button-icon--" + r), t == null || t();
  }, f = () => o("");
  return /* @__PURE__ */ a(
    "button",
    {
      className: `button-icon button-icon--${c} ${m}`,
      onMouseEnter: i,
      onMouseLeave: e,
      onClick: b,
      ...p({ disabled: n, "aria-disabled": n }),
      children: /* @__PURE__ */ a(s, { className: u, onAnimationEnd: f })
    }
  );
}
export {
  A as ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
